import * as mediasoupClient from "mediasoup-client";

let device: mediasoupClient.Device | null = null;

export async function loadDevice(
  routerRtpCapabilities: mediasoupClient.types.RtpCapabilities,
): Promise<mediasoupClient.Device> {
  device = new mediasoupClient.Device();
  await device.load({ routerRtpCapabilities });
  return device;
}

export function getDevice(): mediasoupClient.Device {
  if (!device) {
    throw new Error("Device not initialized");
  }
  return device;
}
